
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  UserRiskBuffList,
  UpdateUserRiskBuff,
  BatchUserRiskBuff,
  RefreshConfig
} from '@/api/admin/risk'
@Component({
  components: {}
})
export default class userRiskBuff extends Vue {
  select = {
    pvp_level_LIst: [
      { value: 2, name: '黑2' },
      { value: 1, name: '黑1' },
      { value: 0, name: '正常' },
      { value: -1, name: '白1' },
      { value: -2, name: '白2' }
    ]
  }
  //表单数据
  table = {
    data: [],
    columns: [
      { type: 'index', title: '序号', width: 50, align: 'center' },
      { key: 'id', align: 'center', title: 'ID', width: 100 },
      {
        key: 'name',
        align: 'center',
        title: '策略执行结果',
        width: 350,
        resizable: true
      },
      {
        key: 'level',
        align: 'center',
        title: 'level',
        width: 250,
        resizable: true
      },
      {
        key: 'pvp_level',
        align: 'center',
        title: 'PVP游戏风控等级/执行概率',
        width: 250,
        resizable: true,
        render: (h, params) => {
          let arr = ['白2', '白1', '正常', '黑1', '黑2']
          let color = ['#32CD32', '#32CD32', '#333', 'red', 'red']
          let list = [
            h(
              'span',
              { style: { color: color[params.row.pvp_level + 2] } },
              arr[params.row.pvp_level + 2]
            ),
            h('span', { style: { margin: '0 2px' } }, '/'),
            h(
              'span',
              { style: { color: '#2d8cf0' } },
              params.row.pvp_exec_rate + '%'
            )
          ]
          return h('span', list)
        }
      },
      {
        key: 'pve_rate',
        align: 'center',
        title: '百人类风控强度/执行概率',
        width: 250,
        resizable: true,
        render: (h, params) => {
          let list = [
            h('span', { style: { color: 'red' } }, params.row.pve_rate + '%'),
            h('span', { style: { margin: '0 2px' } }, '/'),
            h(
              'span',
              { style: { color: '#2d8cf0' } },
              params.row.pve_exec_rate + '%'
            )
          ]
          return h('span', list)
        }
      },
      {
        key: 'prize_rate',
        align: 'center',
        title: '单人游戏返奖率/执行概率',
        width: 250,
        resizable: true,
        render: (h, params) => {
          let list = [
            h('span', { style: { color: 'red' } }, params.row.prize_rate + '%'),
            h('span', { style: { margin: '0 2px' } }, '/'),
            h(
              'span',
              { style: { color: '#2d8cf0' } },
              params.row.signle_exec_rate + '%'
            )
          ]
          return h('span', list)
        }
      },
      {
        title: '管理',
        key: 'action',
        align: 'center',
        minWidth: 150,
        render: (h, params) => {
          return h('div', [
            h(
              'Button',
              {
                props: { type: 'primary' },
                style: { margin: '2px', padding: '3px 8px' },
                on: {
                  click: () => {
                    this.ModalShow()
                    this.setUser_modal.params = {
                      ...params.row
                    }
                  }
                }
              },
              '修改'
            ),
            h(
              'Button',
              {
                props: { type: 'error' },
                style: { margin: '2px', padding: '3px 8px' },
                on: {
                  click: () => this.removemsg(params.row.id)
                }
              },
              '删除'
            )
          ])
        }
      }
    ],
    total: 0,
    pageSizes: [10, 20, 30, 40]
  }

  //玩家buff配置
  setUser_modal = {
    show: false,
    ref: 'setUser',
    params: this.getSetUserParams(),
    rules: {
      name: [
        {
          required: true,
          trigger: 'blur',
          validator: (this as any).simpleVerify('请输入策略执行结果名称')
        }
      ],
      level: [
        {
          required: true,
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (value == null || value < 1) {
              callback('个人等级不能小于0')
            } else {
              callback()
            }
          }
        }
      ],
      pvp_level: this.validateBlurNull('请选择PVP游戏风控等级'),
      prize_rate: [
        {
          required: true,
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (value == null || value < 0) {
              callback('请选择单机返奖率')
            } else {
              callback()
            }
          }
        }
      ],
      pve_rate: this.validateBlurNull('请选择PVE风控强度'),
      pve_exec_rate: this.validateBlurNull('请选择正确的PVE执行概率'),
      pvp_exec_rate: this.validateBlurNull('请输入正确的PVP执行概率'),
      signle_exec_rate: this.validateBlurNull('请输入正确的单机游戏执行概率')
    }
  }
  validateBlurNull(message, trigger = 'blur') {
    return [{ required: true, trigger, validator: this.validateNull(message) }]
  }
  validateNull(message) {
    return (rule, value, callback) => {
      if (value == null) {
        callback(message)
      } else {
        callback()
      }
    }
  }
  Refres() {
    let param = { is_all: 1, refresh_cfg: [1] }
    RefreshConfig(param).then(res => {
      this.$Notice.success({
        title: '操作提示',
        desc: '成功刷新配置'
      })
      this.userRiskBuffList()
    })
  }
  //获取列表
  userRiskBuffList() {
    UserRiskBuffList({}).then(res => {
      this.table.data = res._param.data || []
    })
  }
  //修改新增风控buff
  updateUserRiskBuff() {
    ;(this.$refs[this.setUser_modal.ref] as any).validate(valid => {
      if (valid) {
        let param = { ...this.setUser_modal.params }
        UpdateUserRiskBuff(param).then(res => {
          this.userRiskBuffList()
          this.CloseModal()
        })
      }
    })
  }
  addModal() {
    this.setUser_modal.params = this.getSetUserParams()
    this.ModalShow()
  }
  getSetUserParams() {
    return {
      id: 0,
      level: null,
      pvp_level: 0,
      prize_rate: 0,
      pve_rate: 0,
      name: '',
      signle_exec_rate: 0,
      pvp_exec_rate: 0,
      pve_exec_rate: 0
    }
  }
  ModalShow() {
    ;(this.$refs[this.setUser_modal.ref] as any).resetFields()
    this.setUser_modal.show = true
  }
  CloseModal() {
    ;(this.$refs[this.setUser_modal.ref] as any).resetFields()
    this.setUser_modal.show = false
  }

  // 删除个人风控
  removemsg(id) {
    this.$Modal.confirm({
      title: '确认删除',
      content: '<p>是否确认将该条玩家策略执行结果配置删除。</p>',
      onOk: () => {
        let params = { ids: [id] }
        BatchUserRiskBuff(params).then(res => {
          this.userRiskBuffList()
        })
      },
      onCancel: () => {}
    })
  }

  created() {
    this.userRiskBuffList()
  }
}
